// removed by extract-text-webpack-plugin
module.exports = {"back":"src-assets-css----button-module---back---1NxDq","proceed":"src-assets-css----button-module---proceed---3kApB"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/button.module.css
// module id = 438
// module chunks = 168707334958949